import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';

interface VitalsFormProps {
  vitals: {
    temperature?: number;
    bloodPressure?: string;
    heartRate?: number;
    respiratoryRate?: number;
    oxygenSaturation?: number;
    height?: number;
    weight?: number;
    bloodSugar?: number;
    bmi?: number;
  };
  onChange: (vitals: VitalsFormProps['vitals']) => void;
}

export function VitalsForm({ vitals, onChange }: VitalsFormProps) {
  const handleWeightChange = (weight: number) => {
    onChange({
      ...vitals,
      weight,
      bmi: vitals.height ? parseFloat((weight / (vitals.height * vitals.height)).toFixed(1)) : undefined
    });
  };

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="border-b">
        <CardTitle>Patient Vitals</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label>Temperature (°C)</Label>
            <Input
              type="number"
              step="0.1"
              value={vitals.temperature || ''}
              onChange={(e) => onChange({
                ...vitals,
                temperature: parseFloat(e.target.value)
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Blood Pressure</Label>
            <Input
              placeholder="120/80"
              value={vitals.bloodPressure || ''}
              onChange={(e) => onChange({
                ...vitals,
                bloodPressure: e.target.value
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Heart Rate (bpm)</Label>
            <Input
              type="number"
              value={vitals.heartRate || ''}
              onChange={(e) => onChange({
                ...vitals,
                heartRate: parseInt(e.target.value)
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Respiratory Rate</Label>
            <Input
              type="number"
              value={vitals.respiratoryRate || ''}
              onChange={(e) => onChange({
                ...vitals,
                respiratoryRate: parseInt(e.target.value)
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Oxygen Saturation (%)</Label>
            <Input
              type="number"
              min="0"
              max="100"
              step="1"
              value={vitals.oxygenSaturation || ''}
              onChange={(e) => onChange({
                ...vitals,
                oxygenSaturation: parseInt(e.target.value)
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Height (m)</Label>
            <Input
              type="number"
              step="0.01"
              value={vitals.height || ''}
              onChange={(e) => onChange({
                ...vitals,
                height: parseFloat(e.target.value)
              })}
            />
          </div>
          <div className="space-y-2">
            <Label>Weight (kg)</Label>
            <Input
              type="number"
              step="0.1"
              value={vitals.weight || ''}
              onChange={(e) => handleWeightChange(parseFloat(e.target.value))}
            />
          </div>
          <div className="space-y-2">
            <Label>Blood Sugar (mmol/L)</Label>
            <Input
              type="number"
              step="0.1"
              value={vitals.bloodSugar || ''}
              onChange={(e) => onChange({
                ...vitals,
                bloodSugar: parseFloat(e.target.value)
              })}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
